export default {
    init() {
        //this.showFeature();
        this.showMobileFeatures();
        this.closeMobileFeatures()
        this.openFeaturesDesc();
        this.showMenu();
        this.showMobileIndustries();
        this.showMainFeatures();
        this.initCarousel();
    },

    showMainFeatures() {
        $('.main__footer-btn').click(function (e){
           $('.features-main__container').toggleClass('d-none');
        });
        $('.main__footer-btn-avg').click(function (e){
            $('.features-main__container').toggleClass('d-none');
        });
        $('.main__footer-btn-mobile').click(function (e){
            $('.features-main-mobile__container').toggleClass('d-none');
        });
    },

    showMenu() {

        let _this = this;
        $('.industries-menu__btn').click(function (e){
            let element = $(this);
            let type = element.data('type');
            _this.showFeature(type);
        });
        $('.features-menu__btn').click(function (e){
            let element = $(this);
            let type = element.data('type');
            _this.showFeature(type);
        });
    },

    showFeature(type=''){
        if (type == 'features') {
            if($('.industries-menu__box').hasClass('d-none')){
                $('.features-menu__box').toggleClass('d-none');
                $('.features-menu__container').toggleClass('features__overflow');
            }else{
                $('.industries-menu__box').toggleClass('d-none');
                $('.features-menu__box').toggleClass('d-none');
            }
        }else{
            if($('.features-menu__box').hasClass('d-none')){
                $('.industries-menu__box').toggleClass('d-none');
                $('.features-menu__container').toggleClass('features__overflow');
            }else{
                $('.features-menu__box').toggleClass('d-none');
                $('.industries-menu__box').toggleClass('d-none');
            }
        }
    },

    showMobileFeatures() {
        $('.features-menu-mobile__btn').click(function (e){
            $('.features-menu-mobile__close').toggleClass('navbar-nav-mobile');
            $('.features-menu-mobile__container').toggleClass('navbar-nav-mobile');
            if(!$('.industries-menu-mobile__box').hasClass('d-none')){
                $('.industries-menu-mobile__box').addClass('d-none')
            }
            $('.features-menu-mobile__box').removeClass('d-none')
            $('.close-features-menu-mobile').toggleClass('navbar-nav-mobile');
            $('#mobile-main-nav').addClass('w-100');
        });

    },
    showMobileIndustries(){
        $('.industries-menu-mobile__btn').click(function (e){
            $('.features-menu-mobile__close').toggleClass('navbar-nav-mobile');
            $('.features-menu-mobile__container').toggleClass('navbar-nav-mobile');
            if(!$('.features-menu-mobile__box').hasClass('d-none')){
                $('.features-menu-mobile__box').addClass('d-none')
            }
            $('.industries-menu-mobile__box').removeClass('d-none')
            $('.close-features-menu-mobile').toggleClass('navbar-nav-mobile');
            $('#mobile-main-nav').addClass('w-100');
        });
    },

    closeMobileFeatures() {
        $('.close-features-menu-mobile').click(function (e) {
            $('.features-menu-mobile__close').toggleClass('navbar-nav-mobile');
            $('.features-menu-mobile__container').toggleClass('navbar-nav-mobile');
            $('.close-features-menu-mobile').toggleClass('navbar-nav-mobile');
            $('#mobile-main-nav').removeClass('w-100');
        })
    },

    openFeaturesDesc() {
        $('.features__footer-wrapper-box').click(function (e){
            $(this).next().toggleClass('features__footer-close');
        });
    },
    initCarousel() {
        this.slides = null;
        this.track = null;
        this.current = 0;
        $(document).ready(function() {
            this.slides = document.querySelectorAll('.carousel-slide');
            this.track = document.querySelector('.carousel-track');
            if (!this.track || this.slides.length === 0) {
                return;
            }
            this.current = 0;
            
            this.updateCarousel();

            $('.carousel-btn-next').on('click', () => {
                this.current = (this.current + 1) % this.slides.length;
                this.updateCarousel();
                this.setCarouselInterval(3000);
            });

            $('.carousel-btn-prev').on('click', () => {
                this.current = (this.current - 1 + this.slides.length) % this.slides.length;
                this.updateCarousel();
                this.setCarouselInterval(3000);
            });
            window.addEventListener('resize', this.updateCarousel);
            this.setCarouselInterval(3000);
        }.bind(this));
    },
    updateCarousel() {
        this.slides.forEach((slide, idx) => {
            slide.classList.remove('active');
            slide.style.transform = '';
        });

        this.slides[this.current].classList.add('active');

        let slideWidth = this.slides[0].offsetWidth + parseInt(window.getComputedStyle(this.slides[0]).marginLeft) + parseInt(window.getComputedStyle(this.slides[0]).marginRight);

        // Center the active slide
        let offset = -this.current * slideWidth + (this.track.offsetWidth - slideWidth) / 2;
        this.track.style.transform = `translateX(${offset}px)`;

        // Give neighboring slides a bit more presence
        if (this.slides[this.current - 1]) this.slides[this.current - 1].style.opacity = '0.9';
        if (this.slides[this.current + 1]) this.slides[this.current + 1].style.opacity = '0.9';
    },
    setCarouselInterval(time) {
        const interval = setInterval(() => {
            this.current = (this.current + 1) % this.slides.length;
            this.updateCarousel();
        }, time);

        for (let i = 0; i < interval; i++) {                      
            clearInterval(i);
        }
    }
    

}
